module.exports = "/assets/40fa06f8e9eef0baed8516e42b4ce45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GW.png
// module id = 1420
// module chunks = 0